import React from 'react';
import ReactDOM from 'react-dom';

import { IconGlyphicon } from 'generics/icons';

export class Navbar extends React.Component  {
  //  navbar container component

  combineClasses()  {
    return  ([  this.props.mixClasses  ]).join(" ");
  }


  render()  {
    return (
        <nav className={ this.combineClasses() }  >
          <div className="container">
            {this.props.children}
          </div>
        </nav>
      );
  }

};


export class NavbarNav extends React.Component  {
  //  navbar links group component

  render()  {
    const classes = [ "personal-account-menu", "clearfix" ];
    return (  <ul className={ classes.join(" ") }  >{this.props.children}</ul>  );
  }

};


export class NavbarNavLink extends React.Component  {
  //  generic enough navbar link button component

  render()  {
    const li_classes = ([   "",
                            (this.props.active && "active"),
                            (this.props.disabled && "disabled"),
                            (this.props.hidden && "hidden"),
                            this.props.mixClasses
                        ]).join(" ");

    const a_props = {
        onClick   : this.props.onClick,
        title     : this.props.title,
        href      : this.props.href,
        target    : ( this.props.newtab  &&  "_blank" ),
        rel       : ( this.props.newtab  &&  "noopener noreferrer" ),
        className : (this.props.active && "active")
      };
    return (<li className={li_classes} >
              <a {...a_props}  >
                {this.props.children}
              </a>
            </li>);
  }

};


export class NavbarNavGlyphiconLink extends React.Component  {
  //  navbar link button component with icon and text

  render()  {
    const {  icon,  children,  ...passthrough  }  =  this.props;
    return (  <NavbarNavLink {  ...passthrough  }  >
                <IconGlyphicon type={icon} />&nbsp;{children}
              </NavbarNavLink>  );
  }

};


export class NavbarNavDropdown extends React.Component  {
  //  navbar dropdown menu button component
  constructor(props)  {
    super(props);

    this.state = {  open : false  };
    this.handleOnTriggerClick =  () => this.setState({ open:!this.state.open });
    this.handleOnMenuClick =  () => this.setState({ open:false });
    this.handleDocumentClick =  (evt) => {
       const dropdownRoot = ReactDOM.findDOMNode(this.dropdownRoot);

        if (!dropdownRoot.contains(evt.target)) {
          this.setState({ open :false });
        }
      }
  }


  componentDidMount()  {
    document.addEventListener('click', this.handleDocumentClick);
  }


  componentWillUnmount()  {
    document.removeEventListener('click', this.handleDocumentClick);
  }


  render()  {
    const li_classes = ([   "submenu-open",
                            (this.state.open && "opened"),
                            this.props.mixClasses
                        ]).join(" ");

    return (<li   className={li_classes}  role="button"
                  ref={ (r)  =>  (this.dropdownRoot = r) }
                  onClick={ this.handleOnTriggerClick }
                >

              <a    className=""
                    title={ this.props.title }
                  >
                {this.props.caption}
              </a>

              <ul   className="personal-account-submenu"
                    onClick={this.handleOnMenuClick}
                  >
                {this.props.children}
              </ul>

            </li>);
  }

};


export class NavbarNavDropdownAction extends React.Component  {
  //  navbar dropdown menu entry component

  render()  {
    const li_classes = ([   "",
                            (this.props.active && "active"),
                            (this.props.disabled && "disabled"),
                            (this.props.hidden && "hidden"),
                            this.props.mixClasses
                        ]).join(" ");

    const a_props = {
        onClick : this.props.onClick,
        title   : this.props.title,
        href    : this.props.href,
        target  : ( this.props.newtab  &&  "_blank" ),
        rel     : ( this.props.newtab  &&  "noopener noreferrer" ),
      };
    return (<li className={li_classes} >
              <a  {...a_props}  >
                {this.props.children}
              </a>
            </li>);
  }

};


export class NavbarText extends React.Component  {
  //  navbar links group component

  render()  {
    const classes = [ "nav navbar-text",
                      (this.props.left && "navbar-left"),
                      (this.props.right && "navbar-right")  ]
    return (  <ul className={ classes.join(" ") }  >{this.props.children}</ul>  );
  }

};



